import { FC } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import { CardForm } from '../CardForm';
import { useStyles } from './styles';
import { Grid } from '@material-ui/core';
import { PreviewProps } from './types';
const stripes = loadStripe(`${process.env.REACT_APP_STRIPE_PUBLISHED_KEY}`);

const LicensePreview: FC<PreviewProps> = ({
  paymentMethod,
  totalUsers,
  addonCheckBox,
  coreCheckBox,
  totalPrice,
  corePrice,
  addonPrice,
  finalAmount,
  userAddon,
}) => {
  const classes = useStyles();
  return (
    <>
      <Grid container>
        <Grid item xs={12} className={classes.boxSizingPayment}>
          {paymentMethod === 'card' ? (
            <Elements stripe={stripes}>
              <CardForm
                previewType='card'
                numberOfUsers={totalUsers}
                addonCheckHandle={addonCheckBox}
                coreCheckHandle={coreCheckBox}
                corePrice={corePrice}
                addonPrice={addonPrice}
                finalAmount={finalAmount}
                userAddon={userAddon}
              />
            </Elements>
          ) : paymentMethod === 'invoice' ? (
            <>
              <Elements stripe={stripes}>
                <CardForm
                  previewType='invoice'
                  numberOfUsers={totalUsers}
                  addonCheckHandle={addonCheckBox}
                  coreCheckHandle={coreCheckBox}
                  corePrice={corePrice}
                  addonPrice={addonPrice}
                  finalAmount={finalAmount}
                  userAddon={userAddon}
                />
              </Elements>
            </>
          ) : (
            ''
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default LicensePreview;
